import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Error } from '@mui/icons-material';

const PageContainer = styled.div`
  background-color: var(--color-bg);
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  background: white;
  padding: 48px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,0.1);
  box-shadow: 0 10px 40px rgba(0,0,0,0.05);
  text-align: center;
  max-width: 500px;
  width: 100%;
`;

const IconWrapper = styled.div`
  color: ${props => props.success ? '#50E3C2' : '#FF6B9D'};
  font-size: 64px;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  font-family: var(--font-serif);
  font-size: 2rem;
  margin-bottom: 16px;
  color: var(--color-text);
`;

const Message = styled.p`
  color: var(--color-text-light);
  line-height: 1.6;
  margin-bottom: 32px;
`;

const AmountBox = styled.div`
  background: #f8fafc;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 32px;
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 1.2rem;
  color: var(--color-primary-blue);
`;

const Button = styled(Link)`
  display: inline-block;
  background: var(--color-primary-blue);
  color: white;
  padding: 16px 32px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    background: var(--color-accent);
    transform: translateY(-2px);
  }
`;

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const redirectStatus = searchParams.get('redirect_status');
  const paymentIntent = searchParams.get('payment_intent');
  const [displayAmount, setDisplayAmount] = useState(null);

  useEffect(() => {
    const storedAmount = localStorage.getItem('lastDonationAmount');
    if (storedAmount) {
      setDisplayAmount(storedAmount);
      localStorage.removeItem('lastDonationAmount');
    }
  }, []);

  const success = redirectStatus === 'succeeded';

  return (
    <PageContainer>
      <Card>
        <IconWrapper success={success}>
          {success ? <CheckCircle fontSize="inherit" /> : <Error fontSize="inherit" />}
        </IconWrapper>

        <Title>
          {success ? 'Thank You!' : 'Payment Failed'}
        </Title>

        <Message>
          {success
            ? 'Your generous donation has been received. You are helping us build a stronger community.'
            : 'Something went wrong with your payment request. Please try again.'}
        </Message>

        {success && displayAmount && (
          <AmountBox>
            Amount: CHF {Number(displayAmount).toFixed(2)}
          </AmountBox>
        )}

        {success && paymentIntent && (
          <p style={{ fontSize: '0.8rem', color: '#94a3b8', marginBottom: '24px' }}>
            Transaction ID: {paymentIntent}
          </p>
        )}

        <Button to="/">Return Home</Button>
      </Card>
    </PageContainer>
  );
};

export default PaymentSuccess;